import React from 'react';
import { arrayOf, func, oneOfType, string } from 'prop-types';
import { Col, Input } from 'antd';
import { formatTitle } from './utils';
import styles from './styles';

const TextFilter = ({ defaultValue, name, onSetFilter, title }) => {
  const handleChange = React.useCallback(
    e => onSetFilter(name, e.target.value),
    [name, onSetFilter]
  );

  return (
    <Col xxl={6} xl={8} lg={12} xs={24} style={styles.filter}>
      <span className="grid-filter-label">{formatTitle(title)}</span>
      <Input
        style={styles.filterInput}
        onChange={handleChange}
        defaultValue={defaultValue}
      />
    </Col>
  );
};

TextFilter.propTypes = {
  defaultValue: string,
  name: string,
  onSetFilter: func,
  title: oneOfType([string, arrayOf(string)]),
};

export default TextFilter;
